import { render, staticRenderFns } from "./TableWrapper.vue?vue&type=template&id=61292475&"
import script from "./TableWrapper.vue?vue&type=script&lang=js&"
export * from "./TableWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports